import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = {
  class: "carbon-title"
};
import { ref, watch, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { getServerImage } from '@/utils/images';
export default {
  __name: 'index',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: Number,
      default: 0
    }
  },
  emits: ['update:modelValue', 'change'],
  setup(__props, {
    emit: __emit
  }) {
    const router = useRouter();
    const route = useRoute();
    const props = __props;
    const emit = __emit;
    const activeIndex = ref(props.modelValue);
    const isFirst = ref(true);
    watch(() => props.modelValue, val => {
      activeIndex.value = val;
      console.log('activeIndex changed to', val);
      const item = props.list.find(item => item.id === val);
      if (item) {
        // 只有第一次时自动触发 change 事件
        if (isFirst.value) {
          emit('change', item);
          isFirst.value = false;
        }
      }
    });
    onMounted(() => {});
    const handleClick = item => {
      if (activeIndex.value === item?.id) return;
      activeIndex.value = item?.id;
      // console.log('handleClick changed to', item?.id)
      emit('update:modelValue', item?.id);
      emit('change', item);
      // 只有在详情页时才跳转回根路由
      if (route.params.id) {
        router.push('/lowcarbon');
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, item => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["carbon-wrap", {
            active: activeIndex.value === item?.id
          }]),
          onClick: $event => handleClick(item),
          key: item?.id
        }, [_createElementVNode("img", {
          src: _unref(getServerImage)(item.img),
          alt: item.name
        }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, _toDisplayString(item.name), 1)], 10, _hoisted_2);
      }), 128))]);
    };
  }
};